export { default as main } from '@components/main/main.route';
export { default as update } from '@components/update/update.route';
export { default as login } from '@client/components/user/login/login.route';
export { default as signup } from '@client/components/user/signup/signup.route';
export { default as verify } from '@client/components/user/verify/verify.route';
export { default as reset } from '@client/components/user/reset/reset.route';
export { default as password } from '@client/components/user/password/password.route';
